import './style.css'
import * as THREE from 'three'
import gsap from 'gsap'
// import * as dat from 'lil-gui'
//textures
const textureLoader = new THREE.TextureLoader()

const doorColorTexture = textureLoader.load('/textures/door/color.jpg')
const doorAlphaTexture = textureLoader.load('/textures/door/alpha.jpg')
const doorAmbientOcclusionTexture = textureLoader.load('/textures/door/ambientOcclusion.jpg')
const doorHeightTexture = textureLoader.load('/textures/door/height.jpg')
const doorNormalTexture = textureLoader.load('/textures/door/normal.jpg')
const doorMetalnessTexture = textureLoader.load('/textures/door/metalness.jpg')
const doorRoughnessTexture = textureLoader.load('/textures/door/roughness.jpg')
const matcapTexture = textureLoader.load('/textures/matcaps/1.png')
const gradientTexture = textureLoader.load('/textures/gradients/3.jpg')
//debug
// const gui = new dat.GUI()

// scene
const scene = new THREE.Scene()
//geometric shape
const positionsArray = new Float32Array(9)

const geometry = new THREE.TorusKnotGeometry( 1.1, 0.1, 100, 50 );
const material = new THREE.MeshStandardMaterial()
material.roughness = 0.4

const mesh = new THREE.Mesh(geometry, material)
mesh.position.x = 0.7
mesh.position.y = 0.7
mesh.position.z = 0.7
scene.add(mesh)
//particles
//geometry
const particlesGeometry = new THREE.BufferGeometry()
const count = 5000

const positions = new Float32Array(count * 4)

for(let i = 0; i < count; i++){
    positions[i * 3 + 0] = (Math.random() - 0.5) * 20
    positions[i * 3 + 1] = (Math.random()) * 20
    positions[i * 3 + 2] = (Math.random() - 0.5) * 20
}

particlesGeometry.setAttribute(
    'position',
    new THREE.BufferAttribute(positions, 3)
)

//particles material
const particlesMaterial = new THREE.PointsMaterial({
    color: 'grey',
    size : 0.02,
    sizeAttenuation: true
})
//points
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)
//scroll
let scrollY = window.scrollY

window.addEventListener('scroll', () => 
{
    scrollY = window.scrollY
    
})
//light
const hemisphereLight = new THREE.HemisphereLight(0xff0000, 0x0000ff, 1)
scene.add(hemisphereLight)
//pointlight
const pointLight = new THREE.PointLight(0xff9000, 1, 100, 2)
pointLight.position.set(1, - 0.5, 1)
scene.add(pointLight)
// Rect area light
const rectAreaLight = new THREE.RectAreaLight(0x4e00ff, 3, 1, 1)
rectAreaLight.position.set(- 1.5, 0, 1.5)
rectAreaLight.lookAt(new THREE.Vector3())
scene.add(rectAreaLight)
const spotLight = new THREE.SpotLight(0x78ff00, 1, 10, Math.PI * 0.1, 0.25, 1)
spotLight.position.set(0, 2, 3)
scene.add(spotLight)
//debug
// gui.add(mesh.position, 'y')
//rotation
mesh.rotation.y = Math.PI*2
//axes helper
// const axesHelper = new THREE.AxesHelper(2)
// scene.add(axesHelper)

//sizes

 const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
 }
 window.addEventListener('resize', () =>{
    //update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    //update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    //update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
 })

 window.addEventListener('dblclick', () =>
 {
    if (!document.fullscreenElement)
    {
        canvas.requestFullscreen()
    }
    else{
        document.exitFullscreen()
    }
 })
//camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.z = 3
scene.add(camera)

//renderer
const canvas = document.querySelector('canvas.webgl')
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
}) 
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor ('darkPurple', 10);
//cursor
const cursor = {
    x: 0,
    y:0
}
window.addEventListener('mousemove', (event) =>{
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = - (event.clientX / sizes.height - 0.5)
})
//time
 let clock = new THREE.Clock()
//animations

const tick = () =>
{
    // //time
    const elapsedTime = clock.getElapsedTime()
    // console.log(elapsedTime)
    // //update camera
    camera.position.x = Math.sin(cursor.x * Math.PI * 2) * 3
    camera.position.z = Math.cos(cursor.x * Math.PI * 2) * 2
    camera.position.y = cursor.y * 5
    camera.lookAt(mesh.position)
    mesh.rotation.y += 0.002
    
    // //render
    renderer.render(scene, camera)

    window.requestAnimationFrame(tick)
}
tick()
// import './style.css'
// import * as THREE from 'three'
// import * as dat from 'dat.gui'
// import gsap from 'gsap'

// /**
//  * Debug
//  */
//  const gui = new dat.GUI()

//  const parameters = {
//      materialColor: '#ffeded'
//  }
 
//  gui.addColor(parameters, 'materialColor')

//  /**
//  * Base
//  */
// // Canvas
//  const canvas = document.querySelector('canvas.webgl')

//  // Scene
//  const scene = new THREE.Scene()
//  /**
//  * Objects
//  */

//  const geometry = THREE.BoxGeometry(1, 1, 1)
//  const material = THREE.MeshBasicMaterial({ color: 0xff0000 }) 
//  const cube = new THREE.Mesh(geometry, material)

//  scene.add(cube)
//  /**
//  * Sizes
//  */
//  const sizes = {
//     width: window.innerWidth,
//     height: window.innerHeight
// }

//  //base camera
//  const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
//  camera.position.z = 6
//  scene.add(camera)

// /**
//  * Renderer
//  */
//  const renderer = new THREE.WebGLRenderer({
//     canvas: canvas,
//     alpha: true
// })
// //renderer.setClearAlpha(1)
// renderer.setSize(sizes.width, sizes.height)
// renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// /**
//  * Animate
//  */